import { AppDispatch } from "../../api/store";
import { resetRates } from "../../features/actuarial/rates-slice";
import { resetBorrowerAge, resetBorrowerAgeOptions, resetProfileAge, resetRemainingAge } from "../../features/gms-proposal-forms/age-bracket-and-benefit-amount/age-bracket-and-benefit-amount.slice";
import { resetAmountOfLoans } from "../../features/gms-proposal-forms/amount-of-loans/amount-loans.slice";
import { clearAffiliations, resetBasicInformation } from "../../features/gms-proposal-forms/basic-information/basic-information.slice";
import { resetChannelCommissionService } from "../../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice";
import { resetSalaryRank, resetSalaryRankType } from "../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.slice";
import { resetLevelRanking, resetLevelRankingType } from "../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.slice";
import { resetUniformCoverage } from "../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.slice";
import { resetAgeProfile, resetFundingArrangements, resetGroupClassification, resetTypeOfGroup } from "../../features/gms-proposal-forms/gc-tog-ea-mop/gc-tog-ea-mop-slice";
import { clearFiles, resetLoanMaturityType, setCommissionValue, setNotesContent, setSelectedPaymentTermBox, setServiceValue } from "../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice";
import { resetCoverageType, setSelectedBasicPlansBox, setSelectedProductTypeBox, setSelectedProposalTypeBox, setSelectedPrototypeTypeBox } from "../../features/gms-proposal-forms/types-proposal-product-basic-plan/types-proposal-product-basic-plan-slice";
import { clearIsPrototype } from "../../features/gms-state-and-modal/modal-slice";
import { clearProposalPreparedBy, clearProposalStatus } from "../../features/gms-state-and-modal/state-slice";
import { resetRiders, resetSelectedRiders } from "../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice";

export const resetProposalForm = (dispatch: AppDispatch) => {
    dispatch(resetBasicInformation());
    dispatch(clearAffiliations());
    dispatch(resetGroupClassification());
    dispatch(resetTypeOfGroup());
    dispatch(resetAgeProfile());
    dispatch(resetFundingArrangements());
    dispatch(setSelectedProposalTypeBox(null));
    dispatch(setSelectedPrototypeTypeBox(null));
    dispatch(setSelectedProductTypeBox(null));
    dispatch(setSelectedBasicPlansBox(null));
    
    dispatch(resetAmountOfLoans());

    dispatch(resetCoverageType());
    dispatch(resetLevelRanking());
    dispatch(resetUniformCoverage());
    dispatch(resetSalaryRank());
    dispatch(resetSelectedRiders());

    dispatch(setSelectedPaymentTermBox(null));
    dispatch(resetLoanMaturityType());
    dispatch(resetBorrowerAge());
    dispatch(resetBorrowerAgeOptions());
    dispatch(setNotesContent(''));
    dispatch(resetRiders());  
    
    dispatch(resetSalaryRankType());  
    dispatch(resetLevelRankingType()); 
    
    dispatch(resetChannelCommissionService());
    dispatch(resetRemainingAge());
    dispatch(resetProfileAge());

    dispatch(clearIsPrototype());
    dispatch(resetCoverageType());
    dispatch(resetRates());

    dispatch(clearProposalStatus());
    dispatch(clearProposalPreparedBy());

    dispatch(clearFiles());
    dispatch(setCommissionValue(0));
    dispatch(setServiceValue(0));
};